import { useSelectedFleet } from "hooks/useSelectedFleet";

export function useSystemFeature() {
  const { selectedFleet, selectedDriverProfile } = useSelectedFleet();

  const isDriverPayEnabledForDriver = Boolean(
    !selectedDriverProfile?.driverpay_disabled,
  );
  const isDocumentsEnabledForDriver = Boolean(
    !selectedDriverProfile?.documents_disabled,
  );

  const isDriverPayEnabledForFleet = Boolean(selectedFleet?.enable_driver_pay);
  const isDocumentsEnabledFleet = Boolean(
    selectedFleet?.enable_documents_feature,
  );

  const isDriverPayEnabled =
    isDriverPayEnabledForDriver && isDriverPayEnabledForFleet;
  const isDocumentsEnabled =
    isDocumentsEnabledForDriver && isDocumentsEnabledFleet;

  return {
    isDriverPayEnabled,
    isDocumentsEnabled,
    isDriverPayEnabledForFleet,
    isDocumentsEnabledFleet,
  };
}
